import React, { useState } from 'react';
import { ConfirmModal } from '../ui/Modal';
import { sharesFile } from '../../services/git/gitHistory';
import { gitWords } from '../../services/git/gitSyncStatus';

/**
 * "Discard this change" / "Restore this version" — both put one file's
 * version back, so both ask first (it replaces what is in the app now) and
 * both say when the file holds more than this item (a collection's folders
 * and settings share collection.yaml). `words` (gitSyncStatus.gitWords):
 * "the last sync" / "the last saved version" — synced vs tracked on this device.
 */
export default function GitPutBackButton({ item, mode, onConfirm, disabled, words = gitWords(null) }) {
  const [asking, setAsking] = useState(false);
  const [busy, setBusy] = useState(false);
  const discard = mode === 'discard';
  const label = discard ? 'Discard this change' : 'Restore this version';
  const what = sharesFile(item.path) ? 'the whole collection file — its settings and every folder in it' : `“${item.name}”`;
  const renamedBack = item.kind === 'renamed' && item.previousName && item.previousName !== item.name;
  const message = discard
    ? renamedBack
      ? `${what} goes back to “${item.previousName}”${item.inside ? ', with everything inside it,' : ''} as it was at ${words.last}. Your change is lost.`
      : `${what} goes back to how it was at ${words.last}. Your change is lost.`
    : `${what} goes back to this version. What is in Apiboo now is replaced; ${words.nextRecords}.`;

  const confirm = async () => {
    setAsking(false);
    setBusy(true);
    try {
      await onConfirm();
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className={`git-btn git-btn--ghost git-btn--small${discard ? ' git-btn--danger' : ''}`}
        disabled={disabled || busy}
        onClick={() => setAsking(true)}
      >
        {busy ? 'Working…' : label}
      </button>
      <ConfirmModal
        isOpen={asking}
        onClose={() => setAsking(false)}
        onConfirm={confirm}
        title={discard ? 'Discard this change?' : 'Restore this version?'}
        message={message}
        confirmText={discard ? 'Discard' : 'Restore'}
        type={discard ? 'danger' : 'default'}
      />
    </>
  );
}
